import { Validator } from './validators';
import * as Validators from './validators';

import { Component } from 'preact';
import { Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

export class Field {
  value?: any;
  isValid?: boolean;
  isPristine?: boolean;
  validators?: string[];
  customValidators?: Validator[];

  constructor(validators?: string[], customValidators?: Validator[], defaultValue?: any) {
    this.isPristine = true;
    this.validators = validators || [];
    this.customValidators = customValidators || null;
    this.value = defaultValue;
  }
}

export interface FieldList {
  [fieldName: string]: Field
}

export interface FormOptions {
  pristineUntilEdited?: boolean;
}

export class Form {
  isValid?: boolean;
  isPristine?: boolean;
  fields: FieldList;
  options: FormOptions;

  constructor(fields: FieldList, options?: FormOptions) {
    this.fields = fields;
    this.options = options || {};

    this.isValid = false;
    this.isPristine = true;
  }

  static cloneFrom(form: Form): Form {
    let clonedFields: FieldList = {};
    
    for (let k in form.fields) {
      let prevField = form.fields[k];
      clonedFields[k] = new Field(prevField.validators, prevField.customValidators, prevField.value);
      clonedFields[k].isValid = prevField.isValid;
      clonedFields[k].isPristine = prevField.isPristine;
    }

    let clone: Form = new Form(clonedFields, form.options);
    clone.isPristine = form.isPristine;
    return clone;
  }

  /**
   * A convenience function for updating component state with an updated and
   * validated form instance.
   * 
   * @param component The component whose state will be notified of form updates
   * @param subject The form subject used with hopplerLinkState and its variants
   * @param options Options to handle differing form state keys and callbacks
   */
  static bind(
    component: Component<any, any>,
    subject: Subject<Form>,
    options?: {
      key?: string,
      onChange?: (form: Form) => any
    }
  ) {
    return subject.pipe(distinctUntilChanged()).subscribe(form => {
      Validators.validateForm(form);

      const key = (options && options.key) || 'form';
      component.setState({ [key]: form });

      if (options && options.onChange) {
        options.onChange(form);
      }
    });
  }

  getFirstInvalidFieldName() {
    for (let key in this.fields) {
      const field = this.fields[key];
      if (!field.isValid) {
        return key;
      }
    }
  }
}
